// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

const SegmentActions = Marty.createActionCreators({
  createDynamicSegment(requestId, name, query) {
    const body = {
      type: 'QUERY',
      name,
      query
    }
    return this.app.queries.SegmentQueries.createSegment(requestId, body)
  },

  createStaticSegment(requestId, name, endUserIds, isTemp) {
    const body = {
      type: 'ID_LIST',
      name
    }
    if (isTemp) {
      body.status = 'HIDDEN'
    }
    return this.app.queries.SegmentQueries.createSegment(requestId, body, endUserIds)
  },

  createStaticSegmentBasedOnQuery(requestId, name, query, isTemp) {
    const body = {
      type: 'ID_LIST',
      name,
      query
    }
    if (isTemp) {
      body.status = 'HIDDEN'
    }
    return this.app.queries.SegmentQueries.createSegment(requestId, body)
  },

  addEndUserIdsToStaticSegment(segmentId, endUserIds) {
    return this.app.queries.SegmentQueries.addEndUserIdsToStaticSegment(segmentId, endUserIds)
  }
})

export default SegmentActions



// WEBPACK FOOTER //
// ./src/scripts/actions/SegmentActions.js